export default __webpack_public_path__ + "static/media/kvr-developer-challenge-2026.e1596e48.svg";